/**
 * Returns true when err was thrown after accessing localStorage/cookies/sessionStorage when
 * it's blocked via browsers settings.
 */
export function isSecurityError(err: unknown) {
    return err instanceof DOMException && err.name === 'SecurityError';
}
